const helpers = {
  getDimensions: function getDimensions({ chart, grade, categoryIndex }) {
    const dim = {};
    const colCount = chart.xAxis[0].categories.length;
    const xAxisWidth = chart.xAxis[0].width;
    dim.colWidth = xAxisWidth / colCount;

    //suggested
    categoryIndex = categoryIndex !== undefined ? categoryIndex : this.getCategoryIndex({ chart, grade }); //eslint-disable-line no-param-reassign
    dim.suggestedWidth = dim.colWidth;
    dim.suggestedX = chart.plotLeft + categoryIndex * dim.colWidth;

    const totalHeight = chart.plotSizeY + chart.plotTop + chart.marginBottom;
    const suggestedTopBarY = this.getCategoryMax({ chart, grade }) || 100;
    const bottomToTopBarHeight = totalHeight - suggestedTopBarY;
    dim.suggestedHeight = bottomToTopBarHeight + 60;
    dim.suggestedY = totalHeight - dim.suggestedHeight;

    //suggested text   (has anchor at middle)
    dim.suggestedTextX = dim.suggestedX + dim.colWidth / 2;
    dim.suggestedTextY = dim.suggestedY - 8;

    return dim;
  },

  getCategoryMax: function getCategoryMax({ chart, grade }) {
    if (!grade || grade === 'N/A') return 100;

    const midPointSeries = chart.series.find(series => series.name === 'Midpoint - Maximum (avg)');

    const data = midPointSeries.data.find(bar => bar.category === grade);

    //if no midpoint to max data point is available just return 150
    return data ? data.plotHigh : 150;
  },

  getCategoryIndex: function getCategoryIndex({ chart, grade }) {
    let index;
    chart.xAxis[0].categories.forEach((category, idx) => {
      if (category === grade) index = idx;
    });
    return index || 3;
  },

  buildHoverZones: function(chart, jobGrade, payStructure, recommendGrade, saveJobGrade) {
    let closestGrade;
    const currentGrade = jobGrade;
    if (payStructure === recommendGrade.org_salary_structure) {
      closestGrade = recommendGrade.closest_grade;
    }

    const categories = chart.xAxis[0].categories;
    const catContainerGroup = chart.renderer
      .g()
      .attr({ id: 'category-container', zIndex: 99999999 })
      .add();
    //for some reason svg.appendChild(node) doesn't work! Probably because of Highcharts z-index system which seems
    //to move tags up and down according to their z-index

    categories.forEach((cat, categoryIndex) => {
      const dim = this.getDimensions({ chart, grade: cat, categoryIndex });

      const categoryGroup = chart.renderer
        .g()
        .attr({
          id: 'grade' + cat
        })
        .add(catContainerGroup);

      const categoryRect = this.renderCatRect(chart, cat, closestGrade, currentGrade, dim).add(categoryGroup);
      categoryGroup.type = categoryRect.type;
      categoryGroup.isSelected = categoryRect.isSelected;

      //render labels
      const label = this.renderLabel(chart, cat, closestGrade, currentGrade, dim);
      if (label) label.add(categoryGroup);
      if (categoryGroup.type) categoryGroup.text = label;
      if (categoryGroup.isSelected) categoryGroup.textGroup = label;

      categoryGroup
        .on('mouseenter', this.mouseenterGrade.bind(this, { chart, grade: cat, categoryGroup, categoryRect, dim }))
        .on('mouseleave', this.mouseleaveGrade.bind(this, { chart, grade: cat, categoryGroup, categoryRect, dim }))
        .on('click', saveJobGrade.bind(null, { org_salary_grade: cat }));

      this.addFilterDefinition();
    });
  },

  mouseenterGrade: function(args) {
    const { categoryGroup, categoryRect } = args;
    //get elements and move them into group
    //
    this.adjustTextBeforeAni(args);
    this.regroupCategoryElements(args);

    categoryRect.attr({
      'stroke-opacity': 1
    });

    categoryGroup.toFront();
  },

  mouseleaveGrade: function({ categoryGroup, categoryRect, dim }) {
    this.adjustTextOnMouseLeave({ categoryGroup, dim });

    categoryRect.attr({
      'stroke-opacity': 0
    });
  },

  regroupCategoryElements: function(args) {
    const { chart, grade, categoryGroup } = args;
    const isGrouped = categoryGroup.element.childElementCount > 3;
    if (isGrouped) return;

    chart.series.forEach(series => {
      const seriesGroupEle = this.cloneSeriesGroupEle(series);
      if (seriesGroupEle) categoryGroup.element.appendChild(seriesGroupEle);
      //add Category label
      const categoryTextEle = this.getCategoryTextNode({ chart, grade });
      if (categoryTextEle) categoryGroup.element.appendChild(categoryTextEle);

      series.data.forEach(data => {
        if (data.category === grade && data.graphic && data.graphic.element) {
          seriesGroupEle.appendChild(data.graphic.element);
        }
      });
    });
  },

  adjustTextBeforeAni: function(args) {
    const { chart, categoryGroup, dim } = args;

    if (!categoryGroup.isSelected) {
      categoryGroup.selectThisGradeText = chart.renderer
        .text('Select This Grade', dim.suggestedTextX, dim.suggestedY + dim.suggestedHeight + 15)
        .attr({
          fill: '#a6d452',
          zIndex: 16,
          'text-anchor': 'middle'
        })
        .css({ 'font-size': '10px' })
        .add(categoryGroup);
    }

    if (categoryGroup.isSelected) {
      categoryGroup.textGroup.adjustOnMouseEnter();
    }
  },

  adjustTextOnMouseLeave: function({ categoryGroup }) {
    const { selectThisGradeText } = categoryGroup;
    if (selectThisGradeText) selectThisGradeText.destroy();
  },

  renderCatRect: function(chart, cat, closestGrade, currentGrade, dim) {
    const attr = {
      id: 'gradeRect' + cat,
      zIndex: 15,
      stroke: '#a6d452',
      'stroke-width': 1,
      'stroke-opacity': 0,
      fill: 'white',
      'fill-opacity': 0
    };
    let type;
    let isSelected = false;

    if (cat === closestGrade) {
      attr['fill-opacity'] = 1;
      attr.fill = 'rgba(34, 214, 221, 0.2)';
      type = 'closest';
    }

    if (cat === currentGrade) {
      attr['fill-opacity'] = 1;
      attr.fill = 'rgba(166, 212, 82, 0.2)';
      type = 'current';
      isSelected = true;
    }

    const rect = chart.renderer
      .rect(dim.suggestedX, dim.suggestedY, dim.suggestedWidth, dim.suggestedHeight, 2)
      .attr(attr)
      .css({ cursor: 'pointer' });
    rect.type = type;
    rect.isSelected = isSelected;

    return rect;
  },

  renderLabel: function(chart, cat, closestGrade, currentGrade, dim) {
    let label;

    if (cat === closestGrade) {
      label = chart.renderer
        .text('Suggested', dim.suggestedTextX, dim.suggestedTextY)
        .attr({
          fill: 'rgb(34, 214, 221)',
          zIndex: 16,
          'text-anchor': 'middle'
        })
        .css({ 'font-size': '10px' });
    }

    if (cat === currentGrade) {
      const closestText = label;
      label = chart.renderer.g();

      if (closestText) {
        closestText.add(label);
      }

      // add offset to Y value to cover the border on main catRect
      chart.renderer
        .rect(dim.suggestedX, dim.suggestedY + 0.3, dim.suggestedWidth, 15)
        .attr({ fill: '#a6d452' })
        .add(label);

      chart.renderer
        .text('Selected', dim.suggestedTextX, dim.suggestedY + 11)
        .attr({ fill: 'white', 'text-anchor': 'middle' })
        .css({ 'font-size': '10px' })
        .add(label);

      label.adjustOnMouseEnter = () => {
        label.toFront();
      };
    }

    return label;
  },

  getCategoryTextNode({ chart, grade }) {
    const textElements = chart.xAxis[0].labelGroup.element.children;
    for (let i = 0; i < textElements.length; i++) {
      const ele = textElements[i];
      if (ele.innerHTML === grade || ele.textContent === grade) return ele;
    }
  },

  cloneSeriesGroupEle: function(series) {
    if (series.group && series.group.element) {
      return series.group.element.cloneNode(false);
    }
  },

  addFilterDefinition() {
    const filter = `
        <filter xmlns="http://www.w3.org/2000/svg" id="dropshadow" height="130%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
          <feOffset dx="2" dy="2" result="offsetblur"/>
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.3"/>
          </feComponentTransfer>
          <feMerge>
            <feMergeNode/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      `;
    const defsTag = document.querySelector(`#${this.id} defs`);
    defsTag.innerHTML += filter;
  }
};

export default function applyMixin(ClassToReceive) {
  for (const method in helpers) {
    //eslint-disable-line guard-for-in
    if (Object.hasOwnProperty.call(ClassToReceive.prototype, method)) return;
    ClassToReceive.prototype[method] = helpers[method];
  }
}
